import React from 'react'
import RoleManagementDashboard from '../Dashboard/roleManagement'

function Dashboard() {
  return (
    <>
        <RoleManagementDashboard />
    </>
  )
}

export default Dashboard
